import { custom, deserialize, serializable } from 'serializr';
import { Base, PageObject } from '@testsigmainc/models';
import { JiraIssueField } from './jira-issue-field.model';

export class JiraIssueType extends Base implements PageObject {
  @serializable
  public id: number;
  @serializable
  public name: string;
  @serializable
  public description: string;
  @serializable
  public iconUrl: URL;
  public imgError: boolean;
  @serializable(
    custom(
      (v) => v,
      (v) => {
        const returnValue: JiraIssueField[] = [];
        for (const key in v) {
          returnValue.push(new JiraIssueField().deserialize(v[key]));
        }
        return returnValue;
      },
    ),
  )
  public fields: JiraIssueField[];

  deserialize(input: any): this {
    return Object.assign(this, deserialize(JiraIssueType, input));
  }

  get formFields(): JiraIssueField[] {
    const returnResult: JiraIssueField[] = [];
    const tsFormFields = this.fields.filter((field) => field.canShowOnTSForm);
    returnResult.push(tsFormFields.find((field) => field.isSummaryField));
    returnResult.push(tsFormFields.find((field) => field.isDescriptionField));
    returnResult.push(tsFormFields.find((field) => field.isPriorityField));
    returnResult.push(tsFormFields.find((field) => field.isDueDateField));
    return returnResult.concat(
      tsFormFields.filter(
        (field) =>
          !field.isDueDateField &&
          !field.isPriorityField &&
          !field.isSummaryField &&
          !field.isDescriptionField,
      ),
    );
  }
}
